const defaultGenerator = (componentName) => componentName;
const createClassNameGenerator = () => {
    let generate = defaultGenerator;
    return {
        configure(generator) {
            generate = generator;
        },
        generate(componentName) {
            return generate(componentName);
        },
        reset() {
            generate = defaultGenerator;
        },
    };
};
const ClassNameGenerator = createClassNameGenerator();
const globalStateClassesMapping = {
    active: "Mui-active",
    checked: "Mui-checked",
    completed: "Mui-completed",
    disabled: "Mui-disabled",
    error: "Mui-error",
    expanded: "Mui-expanded",
    focused: "Mui-focused",
    focusVisible: "Mui-focusVisible",
    required: "Mui-required",
    selected: "Mui-selected",
};
export default function generateUtilityClass(componentName, slot) {
    const globalStateClass = globalStateClassesMapping[slot];
    return (globalStateClass || `${ClassNameGenerator.generate(componentName)}-${slot}`);
}
